import classNames from 'classnames/bind';
import { isMobile } from 'react-device-detect';
import { useNavigate } from 'react-router-dom';
import { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Loading from '../Loading';
import styles from './Billing.module.scss';
import { requestPlayerGetGames } from '~/services/game';
import { dispatchPostError } from '~/redux/reducer/error';
import { logoutAccountSuccess } from '~/redux/reducer/auth';

const cx = classNames.bind(styles);

function Billing() {
    const [games, setGames] = useState([]);
    const [loading, setLoading] = useState(true);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { currentUser } = useSelector((state) => state.auth);

    useEffect(() => {
        if (!isMobile) {
            navigate('/app');
        } else {
            if (!currentUser) {
                const fetch = async () => {
                    setLoading(true);

                    const result = await requestPlayerGetGames();

                    setLoading(false);
                    if (result.status === 403) {
                        dispatch(logoutAccountSuccess());
                        localStorage.removeItem('_re');
                        navigate('/');
                        window.location.reload();
                    } else if (result.status === 401) {
                        dispatch(dispatchPostError(result));
                    } else if (result?.status === 200) {
                        setGames(result?.data);
                    }
                };

                fetch();
            } else {
                navigate(`/billing/${currentUser.app.code}`);
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleOpenLoginType = (game) => {
        if (game.login_type === 'account_id') {
            navigate('/freefire-login?ref=billing');
        }

        if (game.login_type === 'garena') {
            navigate(`/garena-login/${game.code}?ref=billing`);
        }
    };

    return (
        <Fragment>
            {loading ? (
                <Loading height="50" />
            ) : (
                <ul className={cx('list')}>
                    {games.map((game, index) => (
                        <li className={cx('item')} key={index}>
                            <div className={cx('box')} onClick={() => handleOpenLoginType(game)}>
                                <div className={cx('image')}>
                                    <img src={game.avatar_url} alt={game.title} />
                                </div>
                                <h2 className={cx('name')}>{game.title}</h2>
                            </div>
                        </li>
                    ))}
                </ul>
            )}
        </Fragment>
    );
}

export default Billing;
